export default __webpack_public_path__ + "static/media/meal.413c88fa.svg";